import React, { FC, ReactNode } from 'react';
import { formatCurrency } from '@factorin/util';

import { useTranslation } from 'Modules/core/i18n';
import { Box, Stack, Typography } from 'Modules/ui3';


interface PersonalAccountBlock {
    account?: string;
    availableFunds?: string;
    icon: ReactNode;
    hasError?: boolean;
}


export const PersonalAccountBlock: FC<PersonalAccountBlock> = ({
    account,
    availableFunds,
    icon,
    hasError = false,
}) => {
    const { t } = useTranslation('personalAccountBlock');

    return (
        <Stack spacing={2}>
            <Stack
                px={4}
                py={3}
                borderRadius={4}
                direction='row'
                sx={{ backgroundColor: 'grayscale.shade10' }}
            >
                <Stack
                    mr={3}
                    width={48}
                    height={48}
                    borderRadius={4}
                    alignItems='center'
                    justifyContent='center'
                    sx={{ backgroundColor: 'grayscale.shade0' }}
                >
                    {icon}
                </Stack>

                <Stack spacing={1}>
                    <Typography
                        color='grayscale.shade95'
                        variant='mediumBody2'
                    >
                        {t('account')} {account ?? '-'}
                    </Typography>

                    <Stack
                        direction='row'
                    >
                        <Typography
                            color='grayscale.shade85'
                            variant='regularCaption3'
                        >
                            {t('availableFunds')} —
                        </Typography>
                        <Typography
                            ml={1}
                            color='grayscale.shade85'
                            variant='regularCaption3'
                            {...hasError && {
                                color: 'infoCustom.red50',
                            }}
                        >
                            {availableFunds ? formatCurrency(Number(availableFunds), '₽') : '-'}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>

            {hasError && (
                <Box>
                    <Typography
                        color='infoCustom.red50'
                        variant='regularCaption1'
                    >
                        {t('insufficientFunds')}
                    </Typography>
                </Box>
            )}
        </Stack>
    );
};
